export type PageQuery = {
  path: string;
  locale: string;
  cjevent?: string;
};
export const removeNonAlphanumericAndSpaces = (inputString?: string) => {
  if (inputString) {
    const regex = /[^a-zA-Z0-9]/g;
    const resultString = inputString.replace(regex, '');
    const trimmed = resultString.trim();
    return trimmed;
  }
  return '';
};

export const getCJPageType = (query: PageQuery) => {
  let pageType = 'homepage';
  if (query) {
    const { path } = query;
    const slugArray = path?.split('/');
    if (slugArray?.length > 0) {
      if (slugArray?.includes('categories') || slugArray?.includes('page')) {
        // first array element is blank that's why length is 3 instead of 2.
        if (slugArray?.length > 3) {
          pageType = 'subCategory';
        } else {
          pageType = 'category';
        }
      }
      if (slugArray?.includes('cart') || slugArray?.includes('checkout')) {
        pageType = 'cart';
      }
      if (slugArray?.includes('search')) {
        pageType = 'searchResults';
      }
      if (slugArray?.includes('products')) {
        pageType = 'productDetail';
      }
      if (slugArray?.includes('thank-you')) {
        pageType = 'conversionConfirmation';
      }
      if (slugArray?.includes('login')) {
        pageType = 'accountSignup';
      }
      if (slugArray?.includes('account')) {
        pageType = 'accountCenter';
      }
      if (slugArray?.includes('blogs')) {
        pageType = 'blogCategories';
      }
      if (slugArray?.includes('blog_entries')) {
        pageType = 'blogPage';
      }
      if (slugArray?.includes('pages')) {
        pageType = 'contentPage';
      }
      if (slugArray?.includes('404')) {
        pageType = 'notFound';
      }
    }
  }
  return pageType;
};

export const getPageType = (query: PageQuery) => {
  let pageType = 'Home';
  if (query) {
    const { path } = query;
    const slugArray = path?.split('/');
    if (slugArray?.length > 0) {
      if (slugArray?.includes('categories') || slugArray?.includes('page')) {
        pageType = 'Category Page';
      }
      if (slugArray?.includes('cart') || slugArray?.includes('checkout')) {
        pageType = 'Cart Page';
      }
      if (slugArray?.includes('search')) {
        pageType = 'Search Page';
      }
      if (slugArray?.includes('products')) {
        pageType = 'Product Page';
      }
      if (slugArray?.includes('thank-you')) {
        pageType = 'Thank you Page';
      }
      if (slugArray?.includes('login')) {
        pageType = 'Login Page';
      }
      if (slugArray?.includes('account')) {
        pageType = 'Account Page';
      }
      if (slugArray?.includes('blogs')) {
        pageType = 'Blog Page';
      }
      if (slugArray?.includes('pages')) {
        pageType = 'Content Page';
      }
      if (slugArray?.includes('404')) {
        pageType = 'Not Found Page';
      }
    }
  }
  return pageType;
};
